<!-- Mobile view (< 768px) -->
<app-mobile-main-dashboard-view
  class="d-md-none"
  [dashboardSummary]="dashboardSummary"
  [rawMaterialsData]="rawMaterialsData"
  [productProjectsData]="productProjectsData"
  [fixedOverheadsData]="fixedOverheadsData"
  [variableOverheadsData]="variableOverheadsData"
  [uniqueRawMaterialUOMs]="uniqueRawMaterialUOMs"
  [uniqueFixedCostPeriods]="uniqueFixedCostPeriods"
  [uniqueVariableCostUOMs]="uniqueVariableCostUOMs"
  [costAllocationData]="costAllocationData"
  [costAllocationOptions]="costAllocationOptions"
  [profitTrendData]="profitTrendData"
  [profitTrendOptions]="profitTrendOptions">
</app-mobile-main-dashboard-view>

<!-- Desktop view (>= 768px) -->
<div class="d-none d-md-block">
<div class="container-fluid">
  <div class="welcome-section mb-4 fade-in">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Main Dashboard</h2>
        <h4 class="welcome-text">System overview and summary</h4>
      </div>
      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{fullName}}</h6>
        <small class="text-muted d-block">{{tenantName}}</small>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center p-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading dashboard data...</p>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!isLoading">
    <!-- Summary Cards Row -->
    <div class="dashboard-cards fade-in mt-3">
      <!-- Raw Materials Summary -->
      <div class="metric-card main" style="flex-grow: 1;">
          <h5>Inventory Value</h5>
        <div class="card-content">
          <div class="icon-container main">
            <i class="bi bi-box-seam" style="color: #007A8F; font-size: 1.2rem;"></i>
          </div>
          <div class="metric-info">
            <div class="d-flex flex-row flex-grow-1 justify-content-evenly" style="align-items: center;">
              <div class="d-flex flex-column">
                <p class="metric-label">Products Total Value</p>
                <span class="fw-bold">{{ dashboardSummary.totalProductValue | currency:'ZAR':'symbol':'1.2-2' }}</span>
              </div>
              <div class="vr mx-2" style="height: 40px; opacity: 0.3;"></div>
              <div class="d-flex flex-column">
                <p class="metric-label">Raw Materials Total Value</p>
                <span class="fw-bold">{{ dashboardSummary.totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>



  <!-- Overheads Summary -->
      <div class="metric-card warning" style="flex-grow: 1;">
        <h5>Overheads</h5>
        <div class="card-content">
          <div class="icon-container warning">
            <i class="bi bi-layers" style="color: #6C7A3E; font-size: 1.2rem;"></i>
          </div>
          <div class="metric-info">
            <div class="d-flex flex-row flex-grow-1 justify-content-evenly" style="align-items: center;">
              <div class="d-flex flex-column">
                <p class="metric-label">Fixed Overheads</p>
                <span class="fw-bold">{{ dashboardSummary.totalFixedOverheads | currency:'ZAR':'symbol':'1.2-2' }}</span>
              </div>
              <div class="vr mx-2" style="height: 40px; opacity: 0.3;"></div>
              <div class="d-flex flex-column">
                <p class="metric-label">Variable Overheads</p>
                <span class="fw-bold">{{ dashboardSummary.totalVariableOverheads | currency:'ZAR':'symbol':'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>





      <!-- Manufacturing Orders Summary -->
      <div class="metric-card success" style="flex-grow: 1;">
        <h5>Manufacturing Orders</h5>
        <div class="card-content">
          <div class="icon-container success">
            <i class="bi bi-gear-fill" style="color: #B0213C; font-size: 1.2rem;"></i>
          </div>
          <div class="metric-info">
            
            <div class="d-flex flex-row flex-grow-1 justify-content-evenly" style="align-items: center;">
              <div class="d-flex flex-column">
                <p class="metric-label">Total Orders</p>
                <span class="fw-bold">{{ dashboardSummary.totalOrders }}</span>
              </div>
              <div class="vr mx-2" style="height: 40px; opacity: 0.3;"></div>
              <div class="d-flex flex-column">
                <p class="metric-label">Pending Orders</p>
                <span class="fw-bold text-warning">{{ dashboardSummary.totalPendingOrders }}</span>
              </div>
              <div class="vr mx-2" style="height: 40px; opacity: 0.3;"></div>
              <div class="d-flex flex-column">
                <p class="metric-label">In Progress</p>
                <span class="fw-bold text-info">{{ dashboardSummary.totalInProgressOrders }}</span>
              </div>
              <div class="vr mx-2" style="height: 40px; opacity: 0.3;"></div>
              <div class="d-flex flex-column">
                <p class="metric-label">Completed Today</p>
                <span class="fw-bold text-success">{{ dashboardSummary.totalCompletedTodayOrders }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    
    </div>

    <!-- Charts and Tables Section -->
    <div class="row mt-4">
      <!-- Cost Breakdown Table -->
      <div class="col-lg-3 mb-2">
        <div class="metric-card" style="height: 400px;">
          <div class="card-body" style="display: flex; flex-direction: column; height: 100%;">
            <div class="CardHeader">
              <div class="d-flex align-items-center">
                <div class="chart-icon-container me-3">
                  <i class="bi bi-pie-chart"></i>
                </div>
                <h3 style="margin-bottom: 5px;">Cost Breakdown</h3>
              </div>
            </div>
            <div class="table-responsive mt-3" style="flex-grow: 1;">
              <table class="table table-sm table-borderless">
                <thead>
                  <tr>
                    <th style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Category</th>
                    <th class="text-end" style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of costBreakdownData">
                    <td>
                      <div class="fw-bold">{{ item.category }}</div>
                    </td>
                    <td class="text-end">
                      {{ item.amount | currency:'ZAR':'symbol':'1.2-2' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Profit Trend Chart -->
      <div class="col-lg-9 mb-2">
        <div class="metric-card" style="height: 400px;">
          <div class="card-body" style="display: flex; flex-direction: column; height: 100%;">
            <div class="CardHeader">
              <div class="d-flex align-items-center">
                <div class="chart-icon-container me-3">
                  <i class="bi bi-graph-up"></i>
                </div>
                <h3 style="margin-bottom: 5px;">Cost Trend</h3>
              </div>
            </div>
            <div style="flex-grow: 1; position: relative;">
              <canvas baseChart [data]="profitTrendData" [options]="profitTrendOptions" type="bar"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tables Section -->
    <div class="row mt-2">
      <!-- Raw Materials Table -->
      <div class="col-lg-3 mb-2">
        <div class="metric-card" style="height: 350px;">
          <div class="card-body" style="display: flex; flex-direction: column; height: 100%;">
            <div class="CardHeader">
              <div class="d-flex align-items-center">
                <div class="chart-icon-container me-3">
                  <i class="bi bi-box-seam"></i>
                </div>
                <h3 style="margin-bottom: 5px;">Raw Materials</h3>
              </div>
            </div>
            <!-- Filter Panel for Raw Materials -->
            <div class="filter-panel" [class.visible]="isFilterPanelOpenRawMaterials">
              <div class="card card-body bg-light mb-2">
                <label class="form-label small">Filter by UOM:</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedRawMaterialUOM" (change)="filterRawMaterials()">
                  <option [ngValue]="null">All Units</option>
                  <option *ngFor="let uom of uniqueRawMaterialUOMs" [ngValue]="uom">{{ uom }}</option>
                </select>
              </div>
            </div>
            <!-- Search Bar for Raw Materials -->
            <div class="d-flex align-items-center gap-2 mb-3" style="padding-top: 5px;">
              <div class="input-group" style="flex: 1;">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search Raw Materials..."
                  [(ngModel)]="rawMaterialsSearchTerm" (input)="filterRawMaterials()" />
              </div>
              <div class="filter-button-container">
                <button class="btn btn-outline-secondary" type="button"
                  (click)="toggleFilterPanelRawMaterials()" [class.active]="isFilterPanelOpenRawMaterials">
                  <i class="bi bi-funnel"></i>
                </button>
              </div>
            </div>
            <div class="table-responsive mt-3" style="flex-grow: 1;">
              <table class="table table-sm table-borderless">
                <thead>
                  <tr>
                    <th style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Material</th>
                    <th class="text-end" style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Quantity</th>
                    <th class="text-end" style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let material of filteredRawMaterialsData">
                    <td>
                      <div class="fw-bold">{{ material.materialName }}</div>
                    </td>
                    <td class="text-end">
                      {{ material.quantity | number:'1.2-2' }} {{ material.uom }}
                    </td>
                    <td class="text-end">
                      {{ material.value | currency:'ZAR':'symbol':'1.2-2' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Total Section -->
            <hr class="my-3">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Total Raw Materials:</h5>
              <h5 class="mb-0">{{ dashboardSummary.totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!-- Products Table -->
      <div class="col-lg-3 mb-2">
        <div class="metric-card" style="height: 350px;">
          <div class="card-body" style="display: flex; flex-direction: column; height: 100%;">
            <div class="CardHeader">
              <div class="d-flex align-items-center">
                <div class="chart-icon-container me-3">
                  <i class="bi bi-box"></i>
                </div>
                <h3 style="margin-bottom: 5px;">Products</h3>
              </div>
            </div>
            <!-- Search Bar for Products -->
            <div class="d-flex align-items-center mb-3" style="padding-top: 5px;">
              <div class="input-group" style="flex: 1;">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search Products..."
                  [(ngModel)]="productsSearchTerm" (input)="filterProducts()" />
              </div>
            </div>
            <div class="table-responsive mt-3" style="flex-grow: 1;">
              <table class="table table-sm table-borderless">
                <thead>
                  <tr>
                    <th style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Product</th>
                    <th class="text-end" style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Quantity</th>
                    <th class="text-end" style="color: #666; font-weight: 600; font-size: 12px; text-transform: uppercase;">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of filteredProductProjectsData">
                    <td>
                      <div class="fw-bold">{{ product.productName }}</div>
                    </td>
                    <td class="text-end">
                      {{ product.quantity | number:'1.2-2' }}
                    </td>
                    <td class="text-end">
                      {{ product.value | currency:'ZAR':'symbol':'1.2-2' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Total Section -->
            <hr class="my-3">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Total Products:</h5>
              <h5 class="mb-0">{{ dashboardSummary.totalProductValue | currency:'ZAR':'symbol':'1.2-2' }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!-- Overheads Table -->
      <div class="col-lg-6 mb-2">
        <div class="metric-card" style="height: 350px;">
          <div class="card-body" style="display: flex; flex-direction: column; height: 100%;">
            <div class="CardHeader">
              <div class="d-flex align-items-center">
                <div class="chart-icon-container me-3">
                  <i class="bi bi-layers"></i>
                </div>
                <h3 style="margin-bottom: 5px;">Overheads</h3>
              </div>
            </div>
            <div class="mt-3" style="flex-grow: 1; display: flex; flex-direction: column; min-height: 0;">
              <div class="row g-2" style="flex-grow: 1; overflow: hidden; min-height: 0;">
                <!-- Fixed Costs Column -->
                <div class="col-6 pe-1" style="display: flex; flex-direction: column; min-height: 0;">
                  <h6 class="text-muted mb-2">Fixed Costs</h6>
                  <!-- Filter Panel for Fixed Costs -->
                  <div class="filter-panel" [class.visible]="isFilterPanelOpenFixedOverheads">
                    <div class="card card-body bg-light mb-2">
                      <label class="form-label small">Filter by Period:</label>
                      <select class="form-select form-select-sm" [(ngModel)]="selectedFixedCostPeriod" (change)="filterFixedOverheads()">
                        <option [ngValue]="null">All Periods</option>
                        <option *ngFor="let period of uniqueFixedCostPeriods" [ngValue]="period">{{ period }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <div class="input-group" style="flex: 1;">
                      <span class="input-group-text"><i class="bi bi-search"></i></span>
                      <input type="text" class="form-control" placeholder="Search fixed costs..."
                        [(ngModel)]="fixedOverheadsSearchTerm" (input)="filterFixedOverheads()" />
                    </div>
                    <button class="btn btn-outline-secondary" type="button"
                      (click)="toggleFilterPanelFixedOverheads()" [class.active]="isFilterPanelOpenFixedOverheads">
                      <i class="bi bi-funnel"></i>
                    </button>
                  </div>
                  <div style="flex-grow: 1; overflow-y: auto; overflow-x: hidden; min-height: 0; max-height: 200px;">
                    <table class="table table-sm table-borderless" style="table-layout: fixed; width: 100%;">
                      <tbody>
                        <tr *ngFor="let overhead of filteredFixedOverheadsData">
                          <td style="width: 65%; padding-right: 5px;">
                            <div class="fw-bold small" style="word-wrap: break-word;">{{ overhead.name }}</div>
                            <small style="color: #666; font-size: 10px; display: block;">{{ overhead.paymentPeriod }}</small>
                          </td>
                          <td class="text-end" style="width: 35%; padding-left: 5px;">
                            <span class="small" style="white-space: nowrap;">{{ overhead.amount | currency:'ZAR':'symbol':'1.0-0' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                <!-- Variable Costs Column -->
                <div class="col-6 ps-1" style="display: flex; flex-direction: column; min-height: 0;">
                  <h6 class="text-muted mb-2">Variable Costs</h6>
                  <!-- Filter Panel for Variable Costs -->
                  <div class="filter-panel" [class.visible]="isFilterPanelOpenVariableOverheads">
                    <div class="card card-body bg-light mb-2">
                      <label class="form-label small">Filter by UOM:</label>
                      <select class="form-select form-select-sm" [(ngModel)]="selectedVariableCostUOM" (change)="filterVariableOverheads()">
                        <option [ngValue]="null">All Units</option>
                        <option *ngFor="let uom of uniqueVariableCostUOMs" [ngValue]="uom">{{ uom }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <div class="input-group" style="flex: 1;">
                      <span class="input-group-text"><i class="bi bi-search"></i></span>
                      <input type="text" class="form-control" placeholder="Search variable costs..."
                        [(ngModel)]="variableOverheadsSearchTerm" (input)="filterVariableOverheads()" />
                    </div>
                    <button class="btn btn-outline-secondary" type="button"
                      (click)="toggleFilterPanelVariableOverheads()" [class.active]="isFilterPanelOpenVariableOverheads">
                      <i class="bi bi-funnel"></i>
                    </button>
                  </div>
                  <div style="flex-grow: 1; overflow-y: auto; overflow-x: hidden; min-height: 0; max-height: 200px;">
                    <table class="table table-sm table-borderless" style="table-layout: fixed; width: 100%;">
                      <tbody>
                        <tr *ngFor="let overhead of filteredVariableOverheadsData">
                          <td style="width: 65%; padding-right: 5px;">
                            <div class="fw-bold small" style="word-wrap: break-word;">{{ overhead.name }}</div>
                            <small style="color: #666; font-size: 10px; display: block;" *ngIf="overhead.totalQuantity > 1">
                              {{ overhead.totalQuantity | number:'1.2-2' }} {{ overhead.uom }} at {{ overhead.unitCost | currency:'ZAR':'symbol':'1.2-2' }}
                            </small>
                            <small style="color: #666; font-size: 10px; display: block;" *ngIf="overhead.totalQuantity === 1">
                              {{ overhead.unitCost | currency:'ZAR':'symbol':'1.2-2' }} each
                            </small>
                          </td>
                          <td class="text-end" style="width: 35%; padding-left: 5px;">
                            <span class="small" style="white-space: nowrap;">{{ overhead.totalCost | currency:'ZAR':'symbol':'1.0-0' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
              <!-- Total Section -->
              <hr class="my-3">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Total Overheads:</h5>
                <h5 class="mb-0">{{ dashboardSummary.totalFixedOverheads + dashboardSummary.totalVariableOverheads | currency:'ZAR':'symbol':'1.2-2' }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
